"use client";
import React, { useState } from "react";
import { Eye, EyeClosed } from "lucide-react";
import { cn } from "../lib/utils";

const InputPassword = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, ...props }, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <div className="relative flex items-center">
      <input
        {...props}
        ref={ref}
        className={cn(
          `flex h-9 w-full rounded-md bg-white border border-zinc-200 px-3 py-1 text-base
          transition-colors file:border-0 file:bg-transparent file:text-sm
          file:font-medium file:text-foreground placeholder:text-muted-foreground
          focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring
          disabled:cursor-not-allowed disabled:opacity-50 md:text-sm`,
          className,
        )}
        type={isVisible ? "text" : "password"}
      />
      <button
        type="button"
        onClick={() => setIsVisible((prev) => !prev)}
        className="absolute top-1/2 right-2.5 -translate-y-1/2"
      >
        {!isVisible ? <EyeClosed size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});

InputPassword.displayName = "InputPassword";
export { InputPassword };
